import _isNumber from 'lodash/isNumber';
import _isString from 'lodash/isString';
import _isFinite from 'lodash/isFinite';
import _size from 'lodash/size';
import _head from 'lodash/head';
import { tget } from '@tekion/tekion-base/utils/general';
import { DEFAULT_DISPLAY_SCALE, DEFAULT_SCALE_TYPE, DISPLAY_SIZES, PROBE_DIV_ELEMENT_HEIGHT, PROBE_DIV_ELEMENT_ID, SCALE_TYPES, DISPLAY_SCALES } from '@tekion/tekion-base/constants/general';
var isPxSizeString = function isPxSizeString(sizeString) {
  return /^\d+(\.\d+)?(px)?$/.test(sizeString);
};
var domScaleTypeKey = 'data-scale-type';
export var getFontSizeFromDOM = function getFontSizeFromDOM() {
  var fontSize = document.querySelector('html').style.fontSize;
  var matches = (fontSize || '').match(/(\d){1,3}(\.\d+)?%/g);
  if (_size(matches) !== 1) return DEFAULT_DISPLAY_SCALE;
  var numericScale = parseFloat(_head(matches));
  if (_isFinite(numericScale)) return numericScale;
  return DEFAULT_DISPLAY_SCALE;
};
export var getScaleTypeFromDOM = function getScaleTypeFromDOM() {
  var htmlDomEl = document.querySelector('html');
  return tget(htmlDomEl, domScaleTypeKey, DEFAULT_SCALE_TYPE);
};
export var setFontSizeInDOM = function setFontSizeInDOM(fontSize) {
  var fontSizeToSet = _isNumber(fontSize) ? fontSize : DEFAULT_DISPLAY_SCALE;
  document.querySelector('html').style.fontSize = "max(".concat(fontSizeToSet, "%)");
};
export var setScaleTypeInDOM = function setScaleTypeInDOM(scaleType) {
  document.querySelector('html')[domScaleTypeKey] = SCALE_TYPES[scaleType] || DEFAULT_SCALE_TYPE;
};
export var getSizeErrorCorrectionFactor = function getSizeErrorCorrectionFactor(displayScale) {
  var calculatedSize = getScaleAdjustedSize(PROBE_DIV_ELEMENT_HEIGHT, {
    isErrorCorrectionEnabled: false,
    currentDisplayScale: displayScale || DEFAULT_DISPLAY_SCALE
  });
  /* Sample height from probe div element in dom and
   * calculate errorCorrectionFactor
   */
  var probeDivEl = document.querySelector("#".concat(PROBE_DIV_ELEMENT_ID));
  if (!probeDivEl) return 0;
  var _getComputedStyle = getComputedStyle(probeDivEl),
    domSizeString = _getComputedStyle.height;
  var domSize = parseFloat(domSizeString.replace('%', ''));
  /* [Fraction of change] errorCorrectionFactor = (domSize - definedSize) / domSize
   * errorCorrectionFactor > 0 => domSize is larger => increase calculated size
   * errorCorrectionFactor < 0 => domSize is smaller => decrease calculated size
   */
  return 1 - calculatedSize / domSize;
};
export var getScaleAdjustedSize = function getScaleAdjustedSize() {
  var sizeInPx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0';
  var extraArgs = arguments.length > 1 ? arguments[1] : undefined;
  var _Object$assign = Object.assign({
      currentDisplayScale: getFontSizeFromDOM(),
      defaultDisplayScale: DEFAULT_DISPLAY_SCALE,
      errorCorrectionFactor: window.pxToRemErrorRate || 0,
      isErrorCorrectionEnabled: true
    }, extraArgs),
    currentDisplayScale = _Object$assign.currentDisplayScale,
    defaultDisplayScale = _Object$assign.defaultDisplayScale,
    errorCorrectionFactor = _Object$assign.errorCorrectionFactor,
    isErrorCorrectionEnabled = _Object$assign.isErrorCorrectionEnabled;
  var sizeToAdjust = _isString(sizeInPx) && isPxSizeString(sizeInPx) ? parseFloat(sizeInPx) : sizeInPx;
  if (!_isNumber(sizeToAdjust)) return sizeInPx;
  var pxScalingFactor = currentDisplayScale / defaultDisplayScale;
  var scaleAdjustedSize = sizeToAdjust * pxScalingFactor;
  if (!isErrorCorrectionEnabled) return scaleAdjustedSize;
  // error-corrected, scale-adjusted size in px
  return scaleAdjustedSize * (1 + errorCorrectionFactor);
};
export var setDisplayScaleAutomatically = function setDisplayScaleAutomatically(width) {
  if (getScaleTypeFromDOM() !== SCALE_TYPES.AUTOMATIC) return;
  var scaleTypeToSet = DEFAULT_DISPLAY_SCALE;
  if (width <= DISPLAY_SIZES.XS) scaleTypeToSet = DISPLAY_SCALES.XS;else if (width <= DISPLAY_SIZES.S) scaleTypeToSet = DISPLAY_SCALES.S;else if (width <= DISPLAY_SIZES.M) scaleTypeToSet = DISPLAY_SCALES.M;
  setFontSizeInDOM(scaleTypeToSet);
};